import { useEffect, useState } from "react";
import { Controller, UseFormWatch, useWatch } from "react-hook-form";
import Input from "../global/Input";
import RadioInput from "../global/RadioInput";

import { useSelector } from "react-redux";

import SelectOption from "../global/SelectOption";
import { selectStyle, selectTheme } from "../../styles/selectStyles";

import Select from "react-select";

import ValidateError from "../global/ValidateError";

import { useGetDictionary } from "../../hooks/useGetDictionary";
import { DictionaryType } from "../../types";
import { CircleHelp } from "lucide-react";
import { Tooltip } from "react-tooltip";
import { MembershipRequest } from "../../types/request/membership";
import { CURRENCY } from "../../constants";

type Props = {
  control: any;
  errors: any;
  setValue: any;
  trigger: any;
  watch: UseFormWatch<MembershipRequest>;
  courts?: { label: string; value: string }[];
  getValues: any;
  eventType: "new" | "edit" | "view" | "duplicate";
};

function MembershipConfigurations({
  control,
  errors,
  watch,
  eventType,
  setValue,
  trigger,
  courts,
  getValues,
}: Props) {
  const { shared, inputs, customers }: DictionaryType = useGetDictionary();
  const autoRenew = watch("auto_renew");
  const pausable = watch("pausable");
  const enabledPausable = useWatch({
    control,
    name: "pausable",
    defaultValue: true, // Provide a default value in case `pausable` is undefined
  });
  const billingCyclePer = useWatch({
    control,
    name: "billing_cycle_per",
  });
  const tooltipContent = `<p>For yearly billing cycle you can select 1 cycle only <br>
For monthly and weekly billing cycle you can select from 1 to 12.</p>`;
  return (
    <div className="flex flex-col gap-8 w-full">
      <h3 className="font-bold text-lg text-primary dark:text-white ">
        {customers.membership_configurations}
      </h3>
      <div className="flex gap-4 w-full items-stretch mobile:flex-wrap">
        <div className="flex-1 flex flex-col gap-8 mobile:min-w-[200px] mobile:gap-2">
          <div className="w-full flex-1">
            <Tooltip
              id="joining-tooltip"
              style={{
                backgroundColor: "#f3f3f3",
                color: "#1e1850",
                top: "0px",
                zIndex: 1000,
              }}
              place="top"
            />
            <label className=" text-sm mb-2 flex whitespace-nowrap ">
              {inputs.joining_fee}
              <span className="text-red-500">*</span>
              <span className="text-xs inline pl-2  ">
                <CircleHelp
                  color="#d1d5db "
                  size={15}
                  className="cursor-context-menu"
                  data-tooltip-id="joining-tooltip"
                  data-tooltip-html={
                    "Paid one time when the player purchases the membership"
                  }
                />
              </span>
            </label>
            <Controller
              name="joining_fee"
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <Input
                  label={""}
                  inputProps={{
                    ...field,
                    className:
                      "block w-full p-2 bg-gray-800 border border-gray-700 rounded-md",
                    type: "number",
                    onWheel: (e) => {
                      e.preventDefault();
                      //@ts-ignore
                      e.target.blur();
                    },
                    step: 0,
                  }}
                  customClass={eventType === "view" ? "bg-[#f2f2f2]" : ""}
                  title={CURRENCY()}
                />
              )}
            />
            {/* @ts-ignore */}
            {errors.joining_fee && <ValidateError />}
          </div>

          {/* <div className="w-full">
            <label className="block text-sm mb-2">
              {inputs.allowed_clubs}
              <span className="text-red-500">*</span>
            </label>
            <ClubSelect
              control={control}
              errors={errors}
              setValue={setValue}
              trigger={trigger}
            />
            {errors.club_ids && <ValidateError />}
          </div> */}
        </div>
        <div className="flex-1 flex flex-col gap-8 mobile:min-w-[200px] mobile:gap-2">
          <div className="flex-1">
            <Tooltip
              id="membership-fee-tooltip"
              style={{
                backgroundColor: "#f3f3f3",
                color: "#1e1850",
                top: "0px",
                zIndex: 1000,
              }}
              place="top"
            />
            <label className=" text-sm mb-2 flex whitespace-nowrap ">
              {inputs.membership_fee}
              <span className="text-red-500">*</span>
              <span className="text-xs inline pl-2  ">
                <CircleHelp
                  color="#d1d5db "
                  size={15}
                  className="cursor-context-menu"
                  data-tooltip-id="membership-fee-tooltip"
                  data-tooltip-html={
                    "Paid when purchasing the membership and on each renewal"
                  }
                />
              </span>
            </label>
            <Controller
              name="membership_fee"
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <Input
                  label={""}
                  customClass={eventType === "view" ? "bg-[#f2f2f2]" : ""}
                  inputProps={{
                    ...field,
                    className:
                      "block w-full p-2 bg-gray-800 border border-gray-700 rounded-md",
                    type: "number",
                    onWheel: (e) => {
                      e.preventDefault();
                      //@ts-ignore
                      e.target.blur();
                    },
                    step: 0,
                  }}
                  title={CURRENCY()}
                />
              )}
            />
            {/* @ts-ignore */}
            {errors.membership_fee && <ValidateError />}
          </div>

          <div className="flex-1 flex h-full items-center"></div>
        </div>
        <div className="col-span-1 flex h-full items-center pt-8">
          <Controller
            name="auto_renew"
            control={control}
            render={({ field }) => (
              <div className="flex flex-row items-center gap-8">
                <label className=" font-bold text-primary dark:text-white">
                  Auto renew?
                </label>
                <RadioInput
                  value="true"
                  label={shared.yes}
                  isDisabled={eventType === "view"}
                  labelStyle="text-primary dark:text-white"
                  //isDisabled={eventType === 'view'}
                  checked={field.value.toString() === "true"}
                  onChange={(value) => {
                    return field.onChange(value === "true");
                  }}
                />
                <RadioInput
                  value="false"
                  label={shared.no}
                  isDisabled={eventType === "view"}
                  labelStyle="text-primary dark:text-white"
                  //isDisabled={eventType === 'view'}
                  checked={field.value.toString() === "false"}
                  onChange={(value) => {
                    return field.onChange(value === "true");
                  }}
                />
              </div>
            )}
          />
        </div>
        { (
          <div className="flex-1">
            <Controller
              name="billing_cycle"
              control={control}
              rules={{
                required: true,
                min: {
                  value: 1,
                  message: "you must select value between 1 and 12",
                },
                max: {
                  value: 12,
                  message: "you must select value between 1 and 12",
                },
              }}
              render={({ field }) => (
                <Input
                  label={inputs.billing_cycle}
                  inputProps={{
                    ...field,
                    type: "number",
                    readOnly:
                      billingCyclePer === "Year" || eventType === "view",
                    disabled:
                      billingCyclePer === "Year" || eventType === "view",
                    onWheel: (e) => {
                      e.preventDefault();
                      //@ts-ignore
                      e.target.blur();
                    },

                    step: 0,
                    className:
                      "block w-full p-2 bg-gray-800 border border-gray-700 rounded-md",
                    onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
                      setValue("billing_cycle", e.target.value);
                      trigger("billing_cycle");
                    },
                  }}
                  customClass={
                    billingCyclePer === "Year" || eventType === "view"
                      ? "bg-[#f2f2f2]"
                      : ""
                  }
                />
              )}
            />
            {/* @ts-ignore */}
            {errors.billing_cycle && (
              <ValidateError errorMessage={errors.billing_cycle.message} />
            )}
          </div>
        )}
        <div className="flex-1 flex flex-col gap-8 mobile:min-w-[200px] mobile:gap-2">
          <Tooltip
            id="billing-tooltip"
            style={{
              backgroundColor: "#f3f3f3",
              color: "#1e1850",
              top: "0px",
              zIndex: 1000,
            }}
            place="top"
          />
          <div className="w-full flex-1">
            <label className=" text-sm mb-2 flex whitespace-nowrap ">
              {inputs.billing_cycle_per}
              <span className="text-red-500">*</span>
              <span className="text-xs inline pl-2  ">
                <CircleHelp
                  color="#d1d5db "
                  size={15}
                  className="cursor-context-menu"
                  data-tooltip-id="billing-tooltip"
                  data-tooltip-html={tooltipContent}
                />
              </span>
            </label>
            <Controller
              control={control}
              name="billing_cycle_per"
              rules={{ required: true }}
              render={({ field }) => (
                <Select
                  components={{
                    IndicatorSeparator: () => null,
                  }}
                  isDisabled={eventType === "view"}
                  {...field}
                  name="billing_cycle_per"
                  styles={selectStyle}
                  classNamePrefix="react-select"
                  theme={selectTheme}
                  options={[
                    { label: inputs.week, value: "Week" },
                    { label: inputs.month, value: "Month" },
                    { label: inputs.year, value: "Year" },
                  ]}
                  onChange={(selected) => {
                    //@ts-ignore
                    if (selected.value === "Year") {
                      setValue("billing_cycle", 1);
                      trigger("billing_cycle");
                    }

                    // @ts-ignore only
                    field.onChange(selected ? selected.value : null);
                  }}
                  value={
                    [
                      { label: inputs.week, value: "Week" },
                      { label: inputs.month, value: "Month" },
                      { label: inputs.year, value: "Year" },
                    ].find((option) => option.value === field.value) || null
                  }
                />
              )}
            />
            {errors.billing_cycle_per && <ValidateError />}
          </div>

          <div className="w-full h-full"></div>
        </div>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4  gap-4 w-full items-stretch mobile:flex-wrap">
        <div className="col-span-1 flex h-full items-center">
          <Controller
            name="pausable"
            control={control}
            render={({ field }) => (
              <div className="flex flex-row items-center gap-8">
                <label className=" font-bold text-primary dark:text-white">
                  Pausable membership?
                </label>
                <RadioInput
                  value="true"
                  isDisabled={eventType === "view"}
                  label={shared.yes}
                  labelStyle="text-primary dark:text-white"
                  //isDisabled={eventType === 'view'}
                  checked={field.value.toString() === "true"}
                  onChange={(value) => {
                    return field.onChange(value === "true");
                  }}
                />
                <RadioInput
                  value="false"
                  isDisabled={eventType === "view"}
                  label={shared.no}
                  labelStyle="text-primary dark:text-white"
                  //isDisabled={eventType === 'view'}
                  checked={field.value.toString() === "false"}
                  onChange={(value) => {
                    return field.onChange(value === "true");
                  }}
                />
              </div>
            )}
          />
        </div>
        {pausable && (
          <div className="col-span-1 ">
            <Controller
              name="max_number_of_pausable_days"
              control={control}
              rules={{
                required: true,
              }}
              render={({ field }) => (
                <Input
                  label={inputs.max_number_of_pause_days}
                  customClass={eventType === "view" ? "bg-[#f2f2f2]" : ""}
                  inputProps={{
                    ...field,
                    className:
                      "block w-full p-2 bg-gray-800 border border-gray-700 rounded-md",
                    type: "number",
                    onWheel: (e) => {
                      e.preventDefault();
                      //@ts-ignore
                      e.target.blur();
                    },
                    step: 0,
                  }}
                  title={inputs.days}
                />
              )}
            />

            {errors.max_number_of_pausable_days && <ValidateError />}
          </div>
        )}
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4  gap-4 w-full items-stretch mobile:flex-wrap">
        <div className="col-span-2 w-full">
          <Controller
            name="terms"
            control={control}
            rules={{ required: true }}
            render={({ field }) => (
              <Input
                label={inputs.terms_and_conditions}
                customClass={eventType === "view" ? "bg-[#f2f2f2]" : ""}
                inputProps={{
                  ...field,
                  className:
                    "block w-full p-2 bg-gray-800 border border-gray-700 rounded-md",
                }}
              />
            )}
          />
          {/* @ts-ignore */}
          {errors.terms && <ValidateError />}
        </div>
      </div>
    </div>
  );
}

type OptionsType = { id: number; name: string };

type ClubProps = {
  control: any;
  errors: any;
  setValue: any;
  trigger: any;
};

const ClubSelect = ({ control, errors, setValue, trigger }: ClubProps) => {
  const clubs = useSelector((state: any) => state.user.clubs); // Replace any with actual state type
  const [options, setOptions] = useState<OptionsType[]>(clubs || []);
  const [loading, setLoading] = useState(false);
  const { placeHolders }: DictionaryType = useGetDictionary();
  useEffect(() => {
    setOptions(clubs); // Update options when clubs change
  }, [clubs]);

  const fetchOptions = () => {
    setLoading(true);
    // Simulate fetching new options if needed
    setTimeout(() => {
      setOptions(clubs);
      setLoading(false);
    }, 500);
  };

  return (
    <Controller
      name="club_ids"
      control={control}
      rules={{
        required: true,
      }}
      render={({ field }) => (
        <Select
          components={{
            IndicatorSeparator: () => null,
            ClearIndicator: () => null,
            Option: SelectOption,
          }}
          styles={selectStyle}
          classNamePrefix="react-select"
          theme={selectTheme}
          {...field}
          isMulti
          options={options}
          getOptionLabel={(option) => option.name}
          getOptionValue={(option) => option.id.toString()}
          onChange={(selected) => {
            const selectedOptions = selected.map((item: any) => ({
              id: item.id,
              name: item.name,
            })); // Keep structure intact
            field.onChange(selectedOptions); // Update form state with full objects
            setValue("club_ids", selectedOptions); // Sync with form state
            trigger("club_ids"); // Trigger validation
          }}
          value={field.value} // Match full objects (id, name) with options
          onMenuOpen={fetchOptions}
          hideSelectedOptions={false}
          isLoading={loading}
          placeholder={placeHolders.select}
        />
      )}
    />
  );
};

export default MembershipConfigurations;
/*

            */
